4<template>
  <b-modal
    v-model="modal"
    :title="title"
    size="lg"
    :no-enforce-focus="true"
    :no-close-on-backdrop="true"
  >
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
      <div class="col-lg-12">
        <form autocomplete="off" @submit.prevent="saveRoom()">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="type_room">Tipo de quarto</label>
                <select
                  id="type_room"
                  v-model="room.type_room"
                  name="type_room"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.room.type_room.$error
                  }"
                >
                  <option value=""></option>
                  <option value="double">Duplo</option>
                  <option value="triple">Triplo</option>
                </select>
                <div
                  v-if="submitted && !$v.room.type_room.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="qty">Quantidade de quartos</label>
                <input
                  id="qty"
                  v-model="room.qty"
                  type="number"
                  min="1"
                  max="9999"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.room.qty.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.room.qty.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-2" style="margin-top:27px">
              <button type="submit" class="btn btn-primary btn-block">Salvar</button>
            </div>
          </div>
        </form>
      </div>
      <div class="row mt-3">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table class="table table-centered table-nowrap table-hover">
            <thead>
              <tr>
                <th width="">Tipo de quarto</th>
                <th width="">Capacidade</th>
                <th width="">Status</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list) in rooms" :key="list.id">
                <td>
                  {{ list.type_room_label }}
                </td>
                <td>
                  {{ list.capacity }}
                </td>
                <td>
                </td>
                <td>
                  <button v-if="user.role === 'Admin'" type="button" @click="loadItem(list.id)" class="link btn btn-outline-dark btn-sm mr-1"><i class="bx bx-edit"></i></button>
                  <button v-if="user.role === 'Admin'" type="button" @click="deleteGroup(list)" class="link btn btn-outline-danger btn-sm"><i class="bx bx-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Fechar</b-button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Swal from 'sweetalert2'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading
  },
  props: {
    hotelId: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Quartos',
      loading: true,
      fullPage: true,
      submitted: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      room: {},
      modal: false,
      modalForm: false
    }
  },
  validations: {
    room: {
      type_room: { required },
      qty: { required }
    }
  },
  mounted () {
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
  },
  methods: {
    ...mapActions('room', {
      getRoom: 'getRoom',
      getAll: 'getAll',
      postData: 'save',
      destroyRoom: 'deleteRoom'
    }),
    loadItem (id) {
      if (id) {
        this.title = 'Editar Convidado'
        // this.gethotel(id).then((data) => {
        //   this.hotel = this.data
        //   if (this.hotel.tags) {
        //     this.hotel.tags = this.hotel.tags.data
        //   }
        // }).then(() => {
        //   this.loading = false
        // })
      }
    },
    open (id = null) {
      this.modal = true
      // this.loading = true
      if (id) {
        // this.getReport({
        //   hotelId: id
        // })

        // return
      }
      // this.loading = false
    },
    async saveRoom () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      this.room.hotel_id = this.hotelId
      await this.postData(this.room).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    getReport (filter) {
      let params = {
        include: 'allocation',
        hotel_id: this.hotelId || null,
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    updateList () {
      this.getReport(this.params)
      // this.$refs.child.getSubscribers()
    },
    deletehotel (hotel) {
      Swal.fire({
        title: 'Você tem certeza ?',
        html: `Será excluído do sistema <b>${hotel.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.destroyhotel(hotel.id).then((res) => {
              successMessage('Sucesso: Convidado excluído com sucesso.', 2500)
              this.close()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    close () {
      this.modal = false
      this.hotel = {}
      this.$v.$reset()
      this.$emit('created')
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('event', ['setting']),
    ...mapState('room', ['rooms', 'pagination']),
    rows () {
      return this.pagination.total
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.modal-header {
  background: #000 !important;
  color: #fff;
}
.border-gray {
  border: 1px solid #e9e9e9;
}
</style>
